import { Component, Input } from '@angular/core';
import { ModalService } from 'src/app/components/modal/modal.service';

@Component({
    selector: 'app-ta-type-edit',
    templateUrl: './ta-type-edit.component.html',
    styleUrls: ['./ta-type-edit.component.scss'],
})
export class TaTypeEditComponent {
    @Input() callbackData: any;
    constructor(private modal: ModalService) {}

    editBtnAction() {
        console.log('CALLBACK RECEIVED', this.callbackData);

        if (this.callbackData) {
            this.callbackData[0].callback(this.callbackData[0].arg[0], this.callbackData[0].arg[1]);
        }
    }
}
